import React, { useState } from 'react';
import { motion } from 'framer-motion';
import AsanaModal from './AsanaModal';

const YogaAsanas = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedAsana, setSelectedAsana] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (asana) => {
    setSelectedAsana(asana);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedAsana(null);
  };

  const yogaAsanas = [
    {
      id: 1,
      name: "Mountain Pose",
      sanskrit: "Tadasana",
      image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "standing",
      difficulty: "Beginner",
      duration: "1-3 minutes",
      benefits: [
        "Improves posture and balance (मुद्रा और संतुलन में सुधार)",
        "Strengthens thighs, knees, and ankles (जांघों, घुटनों और टखनों को मजबूत बनाता है)",
        "Firms abdomen and buttocks (पेट और नितंबों को मजबूत करता है)",
        "Relieves sciatica (कटिस्नायुशूल से राहत)"
      ],
      steps: [
        "Stand with feet together, arms at sides",
        "Distribute weight evenly on both feet",
        "Engage thigh muscles and lift kneecaps",
        "Breathe deeply and hold the pose"
      ]
    },
    {
      id: 2,
      name: "Downward Facing Dog",
      sanskrit: "Adho Mukha Svanasana",
      image: "https://images.unsplash.com/photo-1506629905069-bfda1d2cd5e3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "inversion",
      difficulty: "Beginner",
      duration: "1-3 minutes",
      benefits: [
        "Calms the brain and relieves stress (मस्तिष्क को शांत करता है और तनाव से राहत)",
        "Energizes the body (शरीर को ऊर्जावान बनाता है)",
        "Stretches shoulders, hamstrings, calves (कंधे, हैमस्ट्रिंग, बछड़ों को फैलाता है)",
        "Strengthens arms and legs (हाथों और पैरों को मजबूत बनाता है)"
      ],
      steps: [
        "Start on hands and knees",
        "Tuck toes under and lift hips up",
        "Straighten legs and arms",
        "Hold and breathe deeply"
      ]
    },
    {
      id: 3,
      name: "Warrior I",
      sanskrit: "Virabhadrasana I",
      image: "https://images.unsplash.com/photo-1552196563-55cd4e45efb3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "standing",
      difficulty: "Intermediate",
      duration: "30 seconds - 1 minute each side",
      benefits: [
        "Strengthens legs, glutes, and core (पैर, नितंब और कोर को मजबूत बनाता है)",
        "Opens hips and chest (कूल्हों और छाती को खोलता है)",
        "Improves focus and balance (फोकस और संतुलन में सुधार)",
        "Builds confidence and courage (आत्मविश्वास और साहस बढ़ाता है)"
      ],
      steps: [
        "Step left foot back 3-4 feet",
        "Turn left foot out 45 degrees",
        "Bend right knee over ankle",
        "Raise arms overhead"
      ]
    },
    {
      id: 4,
      name: "Warrior II",
      sanskrit: "Virabhadrasana II",
      image: "https://images.unsplash.com/photo-1588286840104-8957b019727f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "standing",
      benefits: [
        "Strengthens and stretches legs and ankles (पैरों और टखनों को मजबूत और फैलाता है)",
        "Stretches groins, chest, and shoulders (कमर, छाती और कंधों को फैलाता है)",
        "Stimulates abdominal organs (पेट के अंगों को उत्तेजित करता है)",
        "Increases stamina (सहनशक्ति बढ़ाता है)"
      ]
    },
    {
      id: 5,
      name: "Tree Pose",
      sanskrit: "Vrikshasana",
      image: "https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "balance",
      benefits: [
        "Improves balance and stability (संतुलन और स्थिरता में सुधार)",
        "Strengthens thighs, calves, ankles (जांघ, बछड़े, टखने मजबूत बनाता है)",
        "Stretches groins and inner thighs (कमर और भीतरी जांघों को फैलाता है)",
        "Improves concentration (एकाग्रता में सुधार)"
      ]
    },
    {
      id: 6,
      name: "Triangle Pose",
      sanskrit: "Trikonasana",
      image: "https://images.unsplash.com/photo-1573590330506-d48abbc1d917?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "standing",
      benefits: [
        "Stretches and strengthens thighs, knees, and ankles (जांघ, घुटने और टखनों को फैलाता और मजबूत बनाता है)",
        "Stretches hips, groins, hamstrings (कूल्हे, कमर, हैमस्ट्रिंग को फैलाता है)",
        "Opens chest and shoulders (छाती और कंधों को खोलता है)",
        "Relieves stress and anxiety (तनाव और चिंता से राहत)"
      ]
    },
    {
      id: 7,
      name: "Child's Pose",
      sanskrit: "Balasana",
      image: "https://images.unsplash.com/photo-1588286840104-8957b019727f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "restorative",
      benefits: [
        "Relieves stress and anxiety (तनाव और चिंता से राहत)",
        "Stretches hips, thighs, and ankles (कूल्हे, जांघ और टखनों को फैलाता है)",
        "Calms the brain (मस्तिष्क को शांत करता है)",
        "Helps relieve neck and back pain (गर्दन और पीठ दर्द से राहत)"
      ]
    },
    {
      id: 8,
      name: "Cat-Cow Pose",
      sanskrit: "Marjaryasana-Bitilasana",
      icon: "🪷",
      category: "warmup",
      benefits: [
        "Stretches the back torso and neck (पीठ और गर्दन को फैलाता है)",
        "Provides gentle massage to spine (रीढ़ की हड्डी की कोमल मालिश)",
        "Improves flexibility (लचीलेपन में सुधार)",
        "Relieves stress and calms mind (तनाव कम करता है और मन को शांत करता है)"
      ]
    },
    {
      id: 9,
      name: "Cobra Pose",
      sanskrit: "Bhujangasana",
      image: "https://images.unsplash.com/photo-1552196563-55cd4e45efb3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "backbend",
      benefits: [
        "Strengthens the spine (रीढ़ की हड्डी को मजबूत बनाता है)",
        "Stretches chest and lungs (छाती और फेफड़ों को फैलाता है)",
        "Firms the buttocks (नितंबों को मजबूत बनाता है)",
        "Stimulates abdominal organs (पेट के अंगों को उत्तेजित करता है)"
      ]
    },
    {
      id: 10,
      name: "Bridge Pose",
      sanskrit: "Setu Bandhasana",
      image: "https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "backbend",
      benefits: [
        "Stretches chest, neck, and spine (छाती, गर्दन और रीढ़ को फैलाता है)",
        "Strengthens back, buttocks, and hamstrings (पीठ, नितंब और हैमस्ट्रिंग मजबूत)",
        "Improves circulation (रक्त संचार में सुधार)",
        "Calms the brain and reduces anxiety (मस्तिष्क को शांत करता है और चिंता कम करता है)"
      ]
    },
    {
      id: 11,
      name: "Seated Forward Bend",
      sanskrit: "Paschimottanasana",
      image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "seated",
      benefits: [
        "Stretches spine, shoulders, hamstrings (रीढ़, कंधे, हैमस्ट्रिंग फैलाता है)",
        "Stimulates liver, kidneys, ovaries, uterus (यकृत, गुर्दे, अंडाशय, गर्भाशय उत्तेजित)",
        "Improves digestion (पाचन में सुधार)",
        "Calms the brain and relieves stress (मस्तिष्क शांत और तनाव राहत)"
      ]
    },
    {
      id: 12,
      name: "Lotus Pose",
      sanskrit: "Padmasana",
      image: "https://images.unsplash.com/photo-1506629905069-bfda1d2cd5e3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "seated",
      benefits: [
        "Calms the brain (मस्तिष्क को शांत करता है)",
        "Stimulates pelvis, spine, abdomen (श्रोणि, रीढ़, पेट उत्तेजित)",
        "Stretches ankles and knees (टखने और घुटने फैलाता है)",
        "Eases menstrual discomfort (मासिक धर्म की परेशानी कम करता है)"
      ]
    },
    {
      id: 13,
      name: "Camel Pose",
      sanskrit: "Ustrasana",
      image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "backbend",
      benefits: [
        "Stretches entire front of body (शरीर के पूरे सामने के हिस्से को फैलाता है)",
        "Strengthens back muscles (पीठ की मांसपेशियों को मजबूत बनाता है)",
        "Improves flexibility of spine (रीढ़ की लचीलेपन में सुधार)",
        "Stimulates nervous system (तंत्रिका तंत्र को उत्तेजित करता है)"
      ]
    },
    {
      id: 14,
      name: "Eagle Pose",
      sanskrit: "Garudasana",
      image: "https://images.unsplash.com/photo-1552196563-55cd4e45efb3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "balance",
      benefits: [
        "Strengthens and stretches ankles and calves (टखने और बछड़े मजबूत और फैलाता है)",
        "Stretches thighs, hips, shoulders (जांघ, कूल्हे, कंधे फैलाता है)",
        "Improves concentration (एकाग्रता में सुधार)",
        "Improves sense of balance (संतुलन की भावना में सुधार)"
      ]
    },
    {
      id: 15,
      name: "Fish Pose",
      sanskrit: "Matsyasana",
      image: "https://images.unsplash.com/photo-1588286840104-8957b019727f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "backbend",
      benefits: [
        "Stretches deep hip flexors (गहरे कूल्हे फ्लेक्सर्स फैलाता है)",
        "Stretches muscles between ribs (पसलियों के बीच की मांसपेशियों को फैलाता है)",
        "Strengthens muscles of upper back and neck (ऊपरी पीठ और गर्दन की मांसपेशियां मजबूत)",
        "Improves posture (मुद्रा में सुधार)"
      ]
    },
    {
      id: 16,
      name: "Pigeon Pose",
      sanskrit: "Eka Pada Rajakapotasana",
      image: "https://images.unsplash.com/photo-1506629905069-bfda1d2cd5e3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "hip-opener",
      benefits: [
        "Stretches thighs, groins, psoas (जांघ, कमर, psoas फैलाता है)",
        "Opens hips and chest (कूल्हे और छाती खोलता है)",
        "Stimulates abdominal organs (पेट के अंगों को उत्तेजित करता है)",
        "Improves posture (मुद्रा में सुधार)"
      ]
    },
    {
      id: 17,
      name: "Crow Pose",
      sanskrit: "Bakasana",
      image: "https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      category: "arm-balance",
      benefits: [
        "Strengthens arms and wrists (हाथ और कलाई मजबूत बनाता है)",
        "Stretches upper back (ऊपरी पीठ फैलाता है)",
        "Strengthens abdominal muscles (पेट की मांसपेशियां मजबूत)",
        "Improves balance and concentration (संतुलन और एकाग्रता में सुधार)"
      ]
    },
    {
      id: 18,
      name: "Warrior III",
      sanskrit: "Virabhadrasana III",
      icon: "🤸",
      category: "balance",
      benefits: [
        "Strengthens ankles, legs, shoulders, back (टखने, पैर, कंधे, पीठ मजबूत)",
        "Tones abdomen (पेट को टोन करता है)",
        "Improves balance and posture (संतुलन और मुद्रा में सुधार)",
        "Improves memory and concentration (स्मृति और एकाग्रता में सुधार)"
      ]
    },
    {
      id: 19,
      name: "Corpse Pose",
      sanskrit: "Savasana",
      icon: "😴",
      category: "restorative",
      benefits: [
        "Calms brain and relieves stress (मस्तिष्क शांत और तनाव राहत)",
        "Reduces headache, fatigue, insomnia (सिरदर्द, थकान, अनिद्रा कम)",
        "Helps lower blood pressure (रक्तचाप कम करने में मदद)",
        "Promotes deep relaxation (गहरी छूट को बढ़ावा देता है)"
      ]
    },
    {
      id: 20,
      name: "Extended Side Angle",
      sanskrit: "Utthita Parsvakonasana",
      icon: "📏",
      category: "standing",
      benefits: [
        "Strengthens and stretches legs, knees, ankles (पैर, घुटने, टखने मजबूत और फैलाता है)",
        "Stretches groins, spine, waist (कमर, रीढ़, कमर फैलाता है)",
        "Stimulates abdominal organs (पेट के अंगों को उत्तेजित करता है)",
        "Increases stamina (सहनशक्ति बढ़ाता है)"
      ]
    },
    {
      id: 21,
      name: "Chair Pose",
      sanskrit: "Utkatasana",
      icon: "🪑",
      category: "standing",
      benefits: [
        "Strengthens ankles, thighs, calves, spine (टखने, जांघ, बछड़े, रीढ़ मजबूत)",
        "Stretches shoulders and chest (कंधे और छाती फैलाता है)",
        "Stimulates abdominal organs, diaphragm (पेट के अंग, डायाफ्राम उत्तेजित)",
        "Reduces symptoms of flat feet (चपटे पैर के लक्षण कम करता है)"
      ]
    },
    {
      id: 22,
      name: "Plank Pose",
      sanskrit: "Phalakasana",
      icon: "🏋️",
      category: "core",
      benefits: [
        "Strengthens arms, wrists, spine (हाथ, कलाई, रीढ़ मजबूत बनाता है)",
        "Tones abdomen (पेट को टोन करता है)",
        "Improves posture (मुद्रा में सुधार)",
        "Builds endurance and stamina (सहनशीलता और सहनशक्ति बनाता है)"
      ]
    },
    {
      id: 23,
      name: "Side Plank",
      sanskrit: "Vasisthasana",
      icon: "📐",
      category: "core",
      benefits: [
        "Strengthens arms, belly, legs (हाथ, पेट, पैर मजबूत बनाता है)",
        "Stretches and strengthens wrists (कलाई फैलाता और मजबूत बनाता है)",
        "Stretches backs of legs (पैरों की पीठ फैलाता है)",
        "Improves sense of balance (संतुलन की भावना में सुधार)"
      ]
    },
    {
      id: 24,
      name: "Boat Pose",
      sanskrit: "Navasana",
      icon: "⛵",
      category: "core",
      benefits: [
        "Strengthens abdomen, hip flexors, spine (पेट, कूल्हे फ्लेक्सर्स, रीढ़ मजबूत)",
        "Stimulates kidneys, thyroid, intestines (गुर्दे, थायरॉयड, आंतों को उत्तेजित)",
        "Improves digestion (पाचन में सुधार)",
        "Relieves stress (तनाव से राहत)"
      ]
    },
    {
      id: 25,
      name: "Wheel Pose",
      sanskrit: "Urdhva Dhanurasana",
      icon: "🎡",
      category: "backbend",
      benefits: [
        "Stretches chest and lungs (छाती और फेफड़े फैलाता है)",
        "Strengthens arms, shoulders, hands, wrists, legs (हाथ, कंधे, हाथ, कलाई, पैर मजबूत)",
        "Stretches hip flexors (कूल्हे फ्लेक्सर्स फैलाता है)",
        "Stimulates thyroid and pituitary (थायरॉयड और पिट्यूटरी उत्तेजित)"
      ]
    },
    {
      id: 26,
      name: "Headstand",
      sanskrit: "Sirsasana",
      icon: "🤸‍♀️",
      category: "inversion",
      benefits: [
        "Calms brain and relieves stress (मस्तिष्क शांत और तनाव राहत)",
        "Stimulates pituitary and pineal glands (पिट्यूटरी और पाइनल ग्रंथियों को उत्तेजित)",
        "Strengthens arms, legs, spine (हाथ, पैर, रीढ़ मजबूत)",
        "Improves digestion (पाचन में सुधार)"
      ]
    },
    {
      id: 27,
      name: "Shoulder Stand",
      sanskrit: "Sarvangasana",
      icon: "🤸‍♂️",
      category: "inversion",
      benefits: [
        "Calms brain and relieves stress (मस्तिष्क शांत और तनाव राहत)",
        "Stimulates thyroid and prostate glands (थायरॉयड और प्रोस्टेट ग्रंथियों को उत्तेजित)",
        "Stretches neck and shoulders (गर्दन और कंधे फैलाता है)",
        "Improves digestion (पाचन में सुधार)"
      ]
    },
    {
      id: 28,
      name: "Twisted Triangle",
      sanskrit: "Parivrtta Trikonasana",
      icon: "🌀",
      category: "twist",
      benefits: [
        "Strengthens and stretches legs (पैरों को मजबूत बनाता और फैलाता है)",
        "Stretches hips, spine, chest, shoulders (कूल्हे, रीढ़, छाती, कंधे फैलाता है)",
        "Stimulates abdominal organs (पेट के अंगों को उत्तेजित करता है)",
        "Improves sense of balance (संतुलन की भावना में सुधार)"
      ]
    },
    {
      id: 29,
      name: "Half Lord of Fishes",
      sanskrit: "Ardha Matsyendrasana",
      icon: "🐠",
      category: "twist",
      benefits: [
        "Stimulates liver and kidneys (यकृत और गुर्दे उत्तेजित)",
        "Stretches shoulders, hips, neck (कंधे, कूल्हे, गर्दन फैलाता है)",
        "Energizes spine (रीढ़ को ऊर्जावान बनाता है)",
        "Relieves menstrual discomfort (मासिक धर्म की परेशानी से राहत)"
      ]
    },
    {
      id: 30,
      name: "Goddess Pose",
      sanskrit: "Utkata Konasana",
      icon: "👸",
      category: "standing",
      benefits: [
        "Strengthens legs and core (पैर और कोर मजबूत बनाता है)",
        "Opens hips and groins (कूल्हे और कमर खोलता है)",
        "Improves circulation (रक्त संचार में सुधार)",
        "Builds confidence and strength (आत्मविश्वास और शक्ति बनाता है)"
      ]
    },
    {
      id: 31,
      name: "Lizard Pose",
      sanskrit: "Utthan Pristhasana",
      icon: "🦎",
      category: "hip-opener",
      benefits: [
        "Opens hips and hip flexors (कूल्हे और कूल्हे फ्लेक्सर्स खोलता है)",
        "Stretches hamstrings and quadriceps (हैमस्ट्रिंग और क्वाड्रिसेप्स फैलाता है)",
        "Strengthens inner thigh muscles (भीतरी जांघ की मांसपेशियों को मजबूत बनाता है)",
        "Prepares body for deeper poses (गहरे आसनों के लिए शरीर तैयार करता है)"
      ]
    },
    {
      id: 32,
      name: "Wide-Legged Forward Fold",
      sanskrit: "Prasarita Padottanasana",
      icon: "🤸‍♀️",
      category: "forward-fold",
      benefits: [
        "Stretches inner legs and spine (भीतरी पैर और रीढ़ फैलाता है)",
        "Tones abdominal organs (पेट के अंगों को टोन करता है)",
        "Calms brain (मस्तिष्क को शांत करता है)",
        "Relieves mild backache (हल्के पीठ दर्द से राहत)"
      ]
    },
    {
      id: 33,
      name: "Firefly Pose",
      sanskrit: "Tittibhasana",
      icon: "🪲",
      category: "arm-balance",
      benefits: [
        "Strengthens arms and wrists (हाथ और कलाई मजबूत बनाता है)",
        "Stretches inner groins and back torso (भीतरी कमर और पीठ के धड़ को फैलाता है)",
        "Tones belly (पेट को टोन करता है)",
        "Improves sense of balance (संतुलन की भावना में सुधार)"
      ]
    },
    {
      id: 34,
      name: "Scorpion Pose",
      sanskrit: "Vrschikasana",
      icon: "🦂",
      category: "inversion",
      benefits: [
        "Strengthens shoulders, arms, back (कंधे, हाथ, पीठ मजबूत बनाता है)",
        "Stretches chest, shoulders, hip flexors (छाती, कंधे, कूल्हे फ्लेक्सर्स फैलाता है)",
        "Improves balance and concentration (संतुलन और एकाग्रता में सुधार)",
        "Stimulates nervous system (तंत्रिका तंत्र को उत्तेजित करता है)"
      ]
    },
    {
      id: 35,
      name: "King Dancer Pose",
      sanskrit: "Natarajasana",
      icon: "💃",
      category: "balance",
      benefits: [
        "Stretches shoulders and chest (कंधे और छाती फैलाता है)",
        "Stretches thighs, groins, abdomen (जांघ, कमर, पेट फैलाता है)",
        "Strengthens legs and ankles (पैर और टखने मजबूत बनाता है)",
        "Improves balance (संतुलन में सुधार)"
      ]
    },
    {
      id: 36,
      name: "Compass Pose",
      sanskrit: "Parivrtta Surya Yantrasana",
      icon: "🧭",
      category: "twist",
      benefits: [
        "Stretches shoulders and legs (कंधे और पैर फैलाता है)",
        "Opens hips and hamstrings (कूल्हे और हैमस्ट्रिंग खोलता है)",
        "Stimulates abdominal organs (पेट के अंगों को उत्तेजित करता है)",
        "Improves spinal mobility (रीढ़ की गतिशीलता में सुधार)"
      ]
    },
    {
      id: 37,
      name: "Eight-Angle Pose",
      sanskrit: "Astavakrasana",
      icon: "🤹",
      category: "arm-balance",
      benefits: [
        "Strengthens arms and wrists (हाथ और कलाई मजबूत बनाता है)",
        "Strengthens abdominal muscles (पेट की मांसपेशियों को मजबूत बनाता है)",
        "Improves balance and concentration (संतुलन और एकाग्रता में सुधार)",
        "Builds confidence (आत्मविश्वास बनाता है)"
      ]
    },
    {
      id: 38,
      name: "Flying Pigeon",
      sanskrit: "Eka Pada Galavasana",
      icon: "🕊️",
      category: "arm-balance",
      benefits: [
        "Strengthens arms and core (हाथ और कोर मजबूत बनाता है)",
        "Opens hips and stretches hip flexors (कूल्हे खोलता और कूल्हे फ्लेक्सर्स फैलाता है)",
        "Improves balance and focus (संतुलन और फोकस में सुधार)",
        "Builds upper body strength (ऊपरी शरीर की ताकत बनाता है)"
      ]
    },
    {
      id: 39,
      name: "Peacock Pose",
      sanskrit: "Mayurasana",
      icon: "🦚",
      category: "arm-balance",
      benefits: [
        "Strengthens wrists, forearms, abdominal muscles (कलाई, बांह, पेट की मांसपेशियां मजबूत)",
        "Improves digestion (पाचन में सुधार)",
        "Tones abdominal organs (पेट के अंगों को टोन करता है)",
        "Improves sense of balance (संतुलन की भावना में सुधार)"
      ]
    },
    {
      id: 40,
      name: "Lotus Headstand",
      sanskrit: "Urdhva Padmasana in Sirsasana",
      icon: "🪷",
      category: "inversion",
      benefits: [
        "Combines benefits of headstand and lotus (शीर्षासन और पद्मासन के फायदे)",
        "Calms nervous system (तंत्रिका तंत्र को शांत करता है)",
        "Improves concentration and memory (एकाग्रता और स्मृति में सुधार)",
        "Balances hormones (हार्मोन संतुलित करता है)"
      ]
    },
    {
      id: 41,
      name: "Revolved Side Angle",
      sanskrit: "Parivrtta Parsvakonasana",
      icon: "🌀",
      category: "twist",
      benefits: [
        "Strengthens and stretches legs (पैरों को मजबूत बनाता और फैलाता है)",
        "Stretches groins, spine, chest, lungs, shoulders (कमर, रीढ़, छाती, फेफड़े, कंधे फैलाता है)",
        "Stimulates abdominal organs (पेट के अंगों को उत्तेजित करता है)",
        "Increases stamina (सहनशक्ति बढ़ाता है)"
      ]
    },
    {
      id: 42,
      name: "Fallen Angel",
      sanskrit: "Devaduuta Panna Asana",
      icon: "😇",
      category: "arm-balance",
      benefits: [
        "Strengthens arms, shoulders, core (हाथ, कंधे, कोर मजबूत बनाता है)",
        "Improves balance and coordination (संतुलन और समन्वय में सुधार)",
        "Builds confidence and mental strength (आत्मविश्वास और मानसिक शक्ति बनाता है)",
        "Opens chest and shoulders (छाती और कंधे खोलता है)"
      ]
    }
  ];

  const categories = [
    { value: 'all', label: 'All Asanas' },
    { value: 'standing', label: 'Standing' },
    { value: 'seated', label: 'Seated' },
    { value: 'backbend', label: 'Backbends' },
    { value: 'forward-fold', label: 'Forward Folds' },
    { value: 'twist', label: 'Twists' },
    { value: 'balance', label: 'Balance' },
    { value: 'inversion', label: 'Inversions' },
    { value: 'arm-balance', label: 'Arm Balances' },
    { value: 'hip-opener', label: 'Hip Openers' },
    { value: 'core', label: 'Core' },
    { value: 'restorative', label: 'Restorative' },
    { value: 'warmup', label: 'Warm-up' }
  ];

  const filteredAsanas = yogaAsanas.filter(asana => {
    const matchesSearch = asana.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         asana.sanskrit.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || asana.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const getAsanaImage = (asana) => {
    // If already has image, return it
    if (asana.image) return asana.image;
    
    // Fallback images for asanas by category and name
    const fallbackImages = {
      'Warrior III': 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Corpse Pose': 'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Extended Side Angle': 'https://images.unsplash.com/photo-1573590330506-d48abbc1d917?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Chair Pose': 'https://images.unsplash.com/photo-1588286840104-8957b019727f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Plank Pose': 'https://images.unsplash.com/photo-1506629905069-bfda1d2cd5e3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Side Plank': 'https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Boat Pose': 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Wheel Pose': 'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Headstand': 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Shoulder Stand': 'https://images.unsplash.com/photo-1588286840104-8957b019727f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Twisted Triangle': 'https://images.unsplash.com/photo-1506629905069-bfda1d2cd5e3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Half Lord of Fishes': 'https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Goddess Pose': 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Lizard Pose': 'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Wide-Legged Forward Fold': 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Firefly Pose': 'https://images.unsplash.com/photo-1588286840104-8957b019727f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Scorpion Pose': 'https://images.unsplash.com/photo-1506629905069-bfda1d2cd5e3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'King Dancer Pose': 'https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Compass Pose': 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Eight-Angle Pose': 'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Flying Pigeon': 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Peacock Pose': 'https://images.unsplash.com/photo-1588286840104-8957b019727f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Lotus Headstand': 'https://images.unsplash.com/photo-1506629905069-bfda1d2cd5e3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Revolved Side Angle': 'https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      'Fallen Angel': 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80'
    };
    
    return fallbackImages[asana.name] || 'https://images.unsplash.com/photo-1506629905069-bfda1d2cd5e3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80';
  };

  return (
    <section id="asanas" className="section">
      <div className="container">
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          🧘‍♀️ Yoga Asanas Collection
        </motion.h2>
        
        {/* Search and Filter */}
        <motion.div 
          className="search-filter-container"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          style={{
            display: 'flex',
            gap: '1rem',
            marginBottom: '2rem',
            flexWrap: 'wrap',
            justifyContent: 'center'
          }}
        >
          <input
            type="text"
            placeholder="Search asanas..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: '0.8rem 1.2rem',
              border: '2px solid #e1e5e9',
              borderRadius: '25px',
              fontSize: '1rem',
              minWidth: '250px',
              outline: 'none'
            }}
          />
          <select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            style={{
              padding: '0.8rem 1.2rem',
              border: '2px solid #e1e5e9',
              borderRadius: '25px',
              fontSize: '1rem',
              background: 'white',
              cursor: 'pointer'
            }}
          >
            {categories.map(category => (
              <option key={category.value} value={category.value}>
                {category.label}
              </option>
            ))}
          </select>
        </motion.div>

        {/* Results count */}
        <motion.p 
          style={{ textAlign: 'center', marginBottom: '2rem', color: '#666' }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.4 }}
          viewport={{ once: true }}
        >
          Showing {filteredAsanas.length} asana{filteredAsanas.length !== 1 ? 's' : ''}
        </motion.p>

        <div className="asanas-grid">
          {filteredAsanas.map((asana, index) => (
            <motion.div
              key={asana.id}
              className="asana-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, boxShadow: "0 25px 50px rgba(0,0,0,0.2)" }}
              whileTap={{ scale: 0.95 }}
              onClick={() => openModal(asana)}
              style={{ cursor: 'pointer' }}
            >
              <div className="asana-image" style={{
                width: '100%',
                height: '200px',
                borderRadius: '12px',
                overflow: 'hidden',
                marginBottom: '1rem'
              }}>
                <img 
                  src={getAsanaImage(asana)} 
                  alt={asana.name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'transform 0.3s ease'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div style={{
                  display: 'none',
                  width: '100%',
                  height: '100%',
                  backgroundColor: '#f0f0f0',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '3rem'
                }}>
                  {asana.icon || '🧘‍♀️'}
                </div>
              </div>
              <h3 className="asana-name">{asana.name}</h3>
              <p className="asana-sanskrit">{asana.sanskrit}</p>
              
              {asana.difficulty && (
                <div style={{
                  display: 'inline-block',
                  padding: '0.25rem 0.75rem',
                  borderRadius: '15px',
                  fontSize: '0.8rem',
                  fontWeight: 'bold',
                  marginBottom: '1rem',
                  background: asana.difficulty === 'Beginner' ? '#E8F5E8' : 
                            asana.difficulty === 'Intermediate' ? '#FFF3E0' : '#FFEBEE',
                  color: asana.difficulty === 'Beginner' ? '#4CAF50' : 
                        asana.difficulty === 'Intermediate' ? '#FF9800' : '#F44336'
                }}>
                  {asana.difficulty}
                </div>
              )}
              
              <ul className="asana-benefits">
                {asana.benefits.slice(0, 2).map((benefit, benefitIndex) => (
                  <li key={benefitIndex}>{benefit}</li>
                ))}
                {asana.benefits.length > 2 && (
                  <li style={{ fontStyle: 'italic', color: '#667eea' }}>
                    +{asana.benefits.length - 2} more benefits...
                  </li>
                )}
              </ul>
              
              <div style={{
                marginTop: '1rem',
                padding: '0.5rem',
                background: 'linear-gradient(45deg, #667eea, #764ba2)',
                borderRadius: '8px',
                color: 'white',
                fontSize: '0.9rem',
                fontWeight: 'bold'
              }}>
                Click to learn more
              </div>
            </motion.div>
          ))}
        </div>

        {filteredAsanas.length === 0 && (
          <motion.div 
            style={{ textAlign: 'center', padding: '3rem', color: '#666' }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🔍</div>
            <h3>No asanas found</h3>
            <p>Try adjusting your search or filter criteria</p>
          </motion.div>
        )}
      </div>

      <AsanaModal 
        asana={selectedAsana}
        isOpen={isModalOpen}
        onClose={closeModal}
      />
    </section>
  );
};

export default YogaAsanas;
